module.exports = __webpack_public_path__ + "img/plan9.91255c8a.svg";